/* eslint-disable max-len */
import React from 'react';

const Masonry = props => (
  <svg width={19} height={19} {...props}>
    <path
      fill="currentColor"
      d="M3 2h7a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v5h7V3H3zm10-1h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v5h3V3h-3zM3 10h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1zm0 1v5h3v-5H3zm6-1h7a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1zm0 1v5h7v-5H9z"
    />
  </svg>
);

export default Masonry;
